module.exports = __webpack_public_path__ + "static/media/2.c4ea9528.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2.jpg
// module id = 24
// module chunks = 0